import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped module
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedPrice from 'payments-checkout-lib/components/Utilities/FormattedPrice';
import useBuyerOverridesLoading from '../../hooks/useBuyerOverridesLoading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DiscountCodeSubtotal = ({
  subtotal,
  currencyCode
}) => {
  const isBuyerOverridesLoading = useBuyerOverridesLoading();
  const nativeCurrencySymbol = getNativeCurrencySymbol(currencyCode);
  const amountColor = isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default';
  return /*#__PURE__*/_jsxs(Flex, {
    "data-test-id": "discount-code-subtotal",
    flexDirection: "row",
    justifyContent: "space-between",
    marginInline: "600",
    paddingBlock: "200",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.subtotal"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      color: amountColor,
      children: subtotal ? /*#__PURE__*/_jsx(FormattedPrice, {
        currencyCode: currencyCode,
        price: subtotal,
        currencyAndAmountStyle: {
          color: amountColor
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "payments.openAmount",
        options: {
          currencySymbol: nativeCurrencySymbol
        }
      })
    })]
  });
};
export default DiscountCodeSubtotal;